import React from 'react'
import { Card, Button, Form } from 'react-bootstrap';

const ForgetPass = (props) => {
  let { username } = props
  return (
    <Card className="shadow mt-5 mx-auto mb-xt card-width-300">
      <Card.Header>
        <h2 className="text-scb font-weight-bold">SCB Payment Gateway</h2>
        <h6>Merchant Admin Portal</h6>
      </Card.Header>
      <Card.Body>
        <p className="text-scb font-weight-bold">Forgot Password</p>
          <Form.Group controlId="formPassword" className="pt-2">            
            <Form.Label>Please enter your username and we'll send you a temporary password to your registered email.</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your username"
              name="username"
              value={username}
              onChange={props.handleChange}
            />
            <Form.Text className="text-danger">
              {props.authResponse}
            </Form.Text>
          </Form.Group>
          <Button className="mt-4 mb-2" variant="scb" type="button" disabled={username===''} block onClick={() =>props.onResetPassword(username)}>
            Confirm
          </Button>
          <Button className="mt-2 mb-3" variant="outline-secondary" type="button" block onClick={()=>props.onBack(false)}>
            Back
          </Button>
      </Card.Body>
    </Card>
  )
}

export default ForgetPass
